import React from 'react';
import './ContactSection.css';
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone, HiOutlinePaperAirplane, HiOutlineClock } from "react-icons/hi";

const ContactSection = () => {
  return (
    <section className="contact-section" id="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <span className="contact-label">Get In Touch</span>
          <h2 className="contact-title">
            Ready to Expand to <span className="highlight-blue">Asia?</span>
          </h2>
          <p className="contact-description">
            Let's discuss your market entry strategy and how our cultural expertise can accelerate your success in Asian markets.
          </p>
        </div>

        <div className="contact-content-grid">
          {/* Start Your Journey (Form) Card */}
          <div className="form-card">
            <h3 className="card-title-icon">
              <span className="icon"><HiOutlineMail className='contact-icons' /></span> Start Your Journey
            </h3>
            <form className="contact-form" action="https://formspree.io/f/xblzwvlz"
  method="POST" >
              <div className="input-group">
                <input type="text" name="name" placeholder="Your Name" className="form-input" />
                <input type="email" name="_replyto" placeholder="Email Address" className="form-input" />
              </div>
              <input type="text" name="company" placeholder="Company Name" className="form-input full-width company-name" />
              <textarea name="message"
                placeholder="Tell us about your market expansion goals..."
                className="form-textarea full-width"
                rows="4"
              ></textarea>
              <button type="submit" className="send-message-btn">
                Send Message 
              </button>
            </form>
          </div>

          <div className="info-cards">
            {/* Our Offices Card */}
            <div className="office-card">
              <h3 className="card-title-icon">
                <span className="icon"><HiOutlineLocationMarker className='contact-icons' /></span> Our Offices
              </h3>
              <div className="office-location">
                <h4>London, United Kingdom</h4>
                <p>71-75 Shelton Street, <br />
                  Covent Garden, <br />
                  WC2H 9JQ</p>
              </div>
            </div>

            {/* Quick Contact Card */}
            <div className="quick-contact-card">
              <h3 className="card-title-icon">
                <span className="icon"><HiOutlinePhone className='contact-icons' /></span> Quick Contact
              </h3>
              <p className="contact-info">
                <span><HiOutlineMail className='contact-icons' /></span> info@emicstrategies.com
              </p>
              <p className="contact-info">
                <span><HiOutlinePhone className='contact-icons' /></span> +44 
              </p>
              <p className="contact-info">
                <span><HiOutlineClock className='contact-icons' /></span> 24/7 Support Available
              </p>
            </div>
          </div>
        </div>
        
        {/* Footer Response Time Block */}
        <div className="response-time-footer">
          <p className="fast-response-text">
            Fast Response
            <span className="response-detail">We typically respond within 1 business day.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;